import React, {createContext, useContext, useState, useCallback, useEffect} from "react";
import {useHistory} from "react-router-dom";
import {isEqual, isFunction} from "lodash";
import * as actions from '../_redux/invoicesActions';

const InvoicesUIContext = createContext();

export function useInvoicesUIContext() {
  return useContext(InvoicesUIContext);
}

export function InvoicesUIProvider({children}) {
  const history = useHistory();
  const [invoiceTypes, setInvoiceTypes] = useState([]);
  const [queryParams, setQueryParamsBase] = useState({});
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      for (let key in nextQueryParams) {
        if (nextQueryParams.hasOwnProperty(key) && !nextQueryParams[key]) delete nextQueryParams[key]
      }
      const path = history.location.pathname;
      const newQueryParams = new URLSearchParams(nextQueryParams);
      history.replace(`${path}?${newQueryParams.toString()}`);

      return nextQueryParams;
    });
  }, [history]);

  useEffect(() => {
    const getOptions = async () => {
      const result = await actions.getInvoiceTypes();
      setInvoiceTypes(result?.data?.data ?? [])
    };
    void getOptions();
  }, [])

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    invoiceTypes
  };

  return <InvoicesUIContext.Provider value={value}>{children}</InvoicesUIContext.Provider>;
}